import { lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './styles/design-refresh.css';

import Layout from "./pages/Layout";
import Home from "./pages/Home";
import reportWebVitals from './reportWebVitals';
import { LANGS, langPrefix } from "./languages";

// Home stays in the main bundle (it is the landing page); the other pages load on demand,
// which keeps Stripe, Disqus and the legal texts out of the first download.
const Blogs = lazy(() => import("./pages/Blogs"));
const Article = lazy(() => import("./pages/ArticleDetail"));
const Quote = lazy(() => import("./pages/Quote"));
const Confirmation = lazy(() => import("./pages/Confirmation"));
const Paiement = lazy(() => import("./pages/Paiement"));
const PaiementSuccess = lazy(() => import("./pages/PaiementSuccess"));
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const NoPage = lazy(() => import("./pages/NoPage"));

// The same pages in every language, under each language's prefix (none for French).
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {LANGS.map((lang) => {
          const p = langPrefix(lang);
          return (
            <Route key={lang} path={p + "/"} element={<Layout lang={lang} />}>
              <Route index element={<Home lang={lang} />} />
              <Route path={p + "/blog/"} element={<Blogs lang={lang} />} />
              <Route path={p + "/blog/:slug"} element={<Article lang={lang} />} />
              <Route path={p + "/devis-reservation-vtc/"} element={<Quote lang={lang} />} />
              <Route path={p + "/devis-reservation-vtc/confirmation"} element={<Confirmation lang={lang} />} />
              <Route path={p + "/devis-reservation-vtc/paiement"} element={<Paiement lang={lang} />} />
              <Route path={p + "/devis-reservation-vtc/success"} element={<PaiementSuccess lang={lang} />} />
              <Route path={p + "/conditions-generales-de-vente/"} element={<Terms lang={lang} />} />
              <Route path={p + "/mentions-legales/"} element={<Privacy lang={lang} />} />
              <Route path="*" element={<NoPage lang={lang} />} />
            </Route>
          );
        })}
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();